//sku should cost workbench api services
import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from 'src/redux/AxiosClient'
import { skuShouldCostWorkbenchApiRoutes } from 'src/constants/serviceConstants/costModelling.apiRoutes'

//get sku kpis
export const getSkuKPIsAsync = createAsyncThunk(
  'api/should-cost-workbench/get-sku-kpis',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.getSkuKpis, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//get skus based on search
export const getSkuListAsync = createAsyncThunk(
  'api/should-cost-workbench/get-skus-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.getSkuList, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// get sku count
export const getTotalSkuCountAsync = createAsyncThunk(
  'api/should-cost-workbench/get-sku-total-pages',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.getTotalSkuCount, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// set final should cost model
export const setFinalShouldCostModel = createAsyncThunk(
  'api/should-cost-workbench/set-final-should-cost-model',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.setFinalModel, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// get Should Cost Breakdown
export const getShouldCostBreakdownDataAsync = createAsyncThunk(
  'api/should-cost-workbench/get-should-cost-breakdown-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.getShouldCostBreakdownForModel,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

//get should cost models by sku
export const getShouldCostModelsBySkuAsync = createAsyncThunk(
  'api/should-cost-workbench/get-should-cost-models-by-sku',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.getShouldCostModelsBySku,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

//check for mini ifa calculation
export const checkIfaProgressAsync = createAsyncThunk(
  'api/should-cost-workbench/check-Ifa-progress',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.checkIfaProgress, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//download should Cost
export const downloadShouldCostAsync = createAsyncThunk(
  'api/should-cost-workbench/download-should-cost',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.downloadShouldCost, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//get all vendors of sku
export const getAllVendorsOfSkuAsync = createAsyncThunk(
  'api/should-cost-workbench/get-all-vendors-of-sku',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.getAllVendorsForSku,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

//get files attached to Model
export const attachedModelFilesAsync = createAsyncThunk(
  'api/should-cost-workbench/attachedModelFilesData',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.attachFilesToModel, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//get currency exchange rate
export const getCurrencyExchangeRateAsync = createAsyncThunk(
  'api/should-cost-workbench/get-currency-exchange-rate',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes.getCurrencyExchangeRate,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const getMaxDateAsync = createAsyncThunk(
  'api/should-cost-workbench//get-max-date',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', skuShouldCostWorkbenchApiRoutes?.getMaxDate, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//delete sku should cost mapping

export const deleteSKUMappingAsync = createAsyncThunk(
  'api/sku-should-cost-workbench/delete-sku-should-cost-mapping',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes.deleteSkuShouldCostMapping,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const attachModelsToSkuAsync = createAsyncThunk(
  'api/sku-should-cost-workbench/attach-models-to-sku',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes.attachModelsToSku, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//upload sku master file
export const validateFileUploadsync = createAsyncThunk(
  'api/sku-should-cost-workbench/upload-template',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.validateFile, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// download sku master and po standard template
export const downloadFileTemplateAsync = createAsyncThunk(
  'api/sku-should-cost-workbench/download-file-template',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.downloadFile, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//finish upload sku master file
export const fileUploadAsync = createAsyncThunk(
  'api/sku-should-cost-workbench/finish-upload-template',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.uploadFile, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// Get PO Trends Data for SKUs on workbench
export const getVendorPoDataAsync = createAsyncThunk(
  'api/sku-should-cost-workbench/get-vendor-po-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.getVendorPoData, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Get PO Trends Line Chart Data for SKUs on workbench
export const getVendorPoTrendDataAsync = createAsyncThunk(
  'api/sku-should-cost-workbench/get-po-trend-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.getPoTrendData, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Get L1,L2,L3, Vendor filters data for SKUs on workbench
export const getSKUFiltersAsync = createAsyncThunk(
  'api/sku-should-cost-workbench/get-sku-filters-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.getSKUFilters, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// get po and models for what if simulation
export const getPoAndModelsForWorkspaceAsync = createAsyncThunk(
  'api/sku-should-cost-workbench/what-if-simulation/get-po-and-models',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.getPoAndModelsForWorkspace,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// create simulation workspace
export const createSimulationWorkspaceAsync = createAsyncThunk(
  'api/sku-should-cost-workbench/what-if-simulation/create-simulation-workspace',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.createSimulationWorkspace,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)
// get simulation workspace list
export const getSimulationWorkspaceListAsync = createAsyncThunk(
  'api/sku-should-cost-workbench/what-if-simulation/get-simulation-workspace-list',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.getSimulationWorkspaceList,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// delete simulation workspace list
export const deleteSimulationWorkspaceAsync = createAsyncThunk(
  'api/sku-should-cost-workbench/what-if-simulation/delete-simulation-workspace',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.deleteSimulationWorkspace,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

//get-homepage-simulation
export const getSimulationListAsync = createAsyncThunk(
  'api/v1/cost-modelling/simulation/get-homepage-simulations',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.getSimulationList, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//delete-homepage-simulation
export const deleteSimulationAsync = createAsyncThunk(
  '/api/v1/cost-modelling/simulation/delete_simulation',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.deleteSimulation, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//create simulation
export const createSimulationAsync = createAsyncThunk(
  '/api/v1/cost-modelling/simulation/create-simulation',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.createSimulation, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//get bom of simulation for edit page
export const getSimulationBOMForEditAsync = createAsyncThunk(
  'api/v1/cost-modelling/simulation/get-bom-of-simulation-edit',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.getSimulationBOMForEdit,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

//save  bom simulation
export const saveSimulationBOMAsync = createAsyncThunk(
  'api/v1/cost-modelling/simulation/edit-simulation',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.saveSimulationBOM, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// save simulation as should cost model and attach to sku
export const saveSimulationAsShouldCostModelAsync = createAsyncThunk(
  '/api/v1/cost-modelling/simulation/save-simulation-as-model',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.saveSimulationAsShouldCostModel,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

//get mini-ifa and bom chart breakdown
export const getBomTrendViewSimulationAsync = createAsyncThunk(
  '/api/v1/cost-modelling/simulation/get-bom-trend-view-simulation',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.getBomTrendViewSimulation,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// get simulation BOM
export const getSimulationBOMDetailsAsync = createAsyncThunk(
  'api/v1/cost-modelling/simulation/get-simulation-bom-details',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.getSimulationBOMDetails,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

//get simulation mini ifa
export const getSimulationMiniIfaAsync = createAsyncThunk(
  'api/v1/cost-modelling/simulation/get-simulation-mini-ifa',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.getSimulationMiniIfa,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

//get simulation preview data
export const getSimulationPreviewDataAsync = createAsyncThunk(
  'api/v1/cost-modelling/simulation/get-simulation-preview-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes.getSimulationPreviewData,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

//get subcomponent cost based on commodity change
export const getSimulationSubcomponentCostAsync = createAsyncThunk(
  'api/sku-should-cost-workbench/what-if-simulation/get-subcomponent-cost',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.getSimulationSubcomponentCost,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// get subcomponent anchor date duty and tariff
export const getSimulationSubcomponentDutyTariffAsync = createAsyncThunk(
  '/api/v1/cost-modelling/simulation/calculate-updated-hts-cost',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.getSimulationSubcomponentDutyTariff,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

//get subcomponent cost based on commodity change
export const getGTOSuggestedCountriesAsync = createAsyncThunk(
  'api/sku-should-cost-workbench/what-if-simulation/get-gto-suggested-countries',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.getGTOSuggestedCountries,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

//get simulation comparison data
export const getSimulationComparisonDataAsync = createAsyncThunk(
  '/api/v1/cost-modelling/simulation/get-simulation-comparison-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.getSimulationComparisonData,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

//get simulation trend data
export const getTrendDataByWorkspaceAsync = createAsyncThunk(
  '/api/v1/cost-modelling/simulation/get-trend-by-workspace',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.getTrendDataByWorkspace,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// bulk model creation for no model SKUs
export const triggerModelCreationAsync = createAsyncThunk(
  '/api/v1/cost-modelling/trigger-model-creation',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.triggerModelCreation,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// get logs percentage for AI Should Costing
export const getLogsPercentageAiShouldCostingAsync = createAsyncThunk(
  '/api/v1/cost-modelling/get-logs',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'GET',
      skuShouldCostWorkbenchApiRoutes?.getLogsPercentageAiShouldCosting,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// get sku data
export const getSkuMetaDataAsync = createAsyncThunk(
  '/api/v1/cost-modelling/get-sku-meta-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.getSkuMetaData, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// get sku-workspace meta data
export const getWorkspaceMetaDataAsync = createAsyncThunk(
  '/api/v1/cost-modelling/get-workspace-meta-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.getWorkspaceMetaData,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

//get simulation meta data
export const getSimulationMetaDataAsync = createAsyncThunk(
  '/api/v1/cost-modelling/get-simulation-meta-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.getSimulationMetaData,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// get simulation baseModel details
export const getBaseModelDataAsync = createAsyncThunk(
  '/api/v1/cost-modelling/get-base-model-details',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.getBaseModelData, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//generate simulation description using Gen AI
export const generateSimulationDescriptionAsync = createAsyncThunk(
  '/api/v1/cost-modelling/simulation/refresh-description',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.generateDescription,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)
export const getSkuExtrapolationGroupOptionList = createAsyncThunk(
  'api/sku-should-cost-workbench/get-sku-extrapolation-group-option-list-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'GET',
      skuShouldCostWorkbenchApiRoutes?.getExtrapolationGroupOptionList,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)
export const getSkuExtrapolationGroupData = createAsyncThunk(
  'api/sku-should-cost-workbench/get-sku-extrapolation-group-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.getExtrapolationGroupData,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)
export const createSkuExtrapolationGroup = createAsyncThunk(
  'api/sku-should-cost-workbench/create-sku-extrapolation-group',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.createExtrapolationGroup,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
    )
  },
)

// get representative skus count
export const getRepresentativeSkusCountAsync = createAsyncThunk(
  '/api/v1/cost-modelling/get-total-count-of-representative-sku-groups',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.getRepresentativeSkusCount,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// get representative skus of group id
export const getRepresentativeSkusAsync = createAsyncThunk(
  '/api/v1/cost-modelling/get-representative-sku-groups',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.getRepresentativeSkus,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// get representative skus of group id
export const replaceRepresentativeSkusAsync = createAsyncThunk(
  '/api/v1/cost-modelling/replace-representative-sku',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.replaceRepresentativeSku,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// get representative skus of group id
export const generateAiBasedModelsAsync = createAsyncThunk(
  '/api/v1/cost-modelling/generate-ai-based-models',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.generateAiBasedModels,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)
// cancel sku grouping
export const cancelSkuGroupingAsync = createAsyncThunk(
  '/api/v1/cost-modelling/cancel-sku-groups',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', skuShouldCostWorkbenchApiRoutes?.cancelSkuGrouping, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
// delete sku grouping
export const deleteSkuGroupingAsync = createAsyncThunk(
  '/api/v1/cost-modelling/delete-sku-groups',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'DELETE',
      skuShouldCostWorkbenchApiRoutes?.deleteSkuGrouping,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)
// get ai generated sku models
export const getAiGeneratedSkuGroupModelsAsync = createAsyncThunk(
  '/api/v1/cost-modelling/review-ai-generated-models',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.aiGeneratedSkuGroupModels,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// get ai generated sku models
export const abortModelGenerationAsync = createAsyncThunk(
  '/api/v1/cost-modelling/abort-model-creation',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.abortModelGeneration,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// get sku list for extrapolation
export const fetchSkuListForExtrapolationAsync = createAsyncThunk(
  '/api/v1/cost-modelling/fetch-sku-list-for-extrapolation',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.fetchSkuListForExtrapolation,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// get count of sku list for extrapolation
export const getTotalSkuListForExtrapolationCountAsync = createAsyncThunk(
  '/api/v1/cost-modelling/sku-list-for-extrapolation-count',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.getTotalSkuListForExtrapolationCount,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)
//  start extrapolation process
export const startExtraPolationProcessAsync = createAsyncThunk(
  '/api/v1/cost-modelling/start-extrapolation-process',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.startExtraPolationProcess,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
    )
  },
)

// save selected sku ids for extrapolation
export const saveSkuGroupMappingIdsAsync = createAsyncThunk(
  '/api/v1/cost-modelling/sku-group-mapping-ids',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.saveSkuGroupMappingIds,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const getExtraPolationLogsPercentageAsync = createAsyncThunk(
  '/api/v1/cost-modelling/get-extrapolation-process',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.getExtraPolationLogsPercentage,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)
export const getShortlistingLogsPercentageAsync = createAsyncThunk(
  '/api/v1/cost-modelling/pipeline-run-logs/activity',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'GET',
      skuShouldCostWorkbenchApiRoutes?.getShortlistingLogsPercentage,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// save selected sku ids for extrapolation
export const getExtrapolationLogAsync = createAsyncThunk(
  '/api/v1/cost-modelling/sku-should-cost-extrapolation-log',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', skuShouldCostWorkbenchApiRoutes?.getExtrapolationLog, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const cancelExtrapolationAsync = createAsyncThunk(
  '/api/v1/cost-modelling/cancel-adf-trigger-pipeline',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.cancelExtrapolation,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const completeReviewAsync = createAsyncThunk(
  '/api/v1/cost-modelling/update-is-reviewed-model-status',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.completeReview, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const skipAccurateModelGenerationFlowAsync = createAsyncThunk(
  '/api/v1/cost-modelling/skip-accurate-flow',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.skipAccurateModelGenerationFlow,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// get commodity uom conversion rates
export const getCommodityUomConversionRatesAsync = createAsyncThunk(
  '/api/v1/cost-modelling/get-uom-conversion-rates',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.getCommodityUomConversionRates,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// get filters for sku landing page
export const getSkuLandingPageFiltersAsync = createAsyncThunk(
  'api/cost-modelling/get-sku-landing-pape-filters',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.getFilters, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// get filters for reviewing/shortlisting uploaded should cost models
export const getReviewModelsFiltersAsync = createAsyncThunk(
  'api/cost-modelling/get-review-models-filters',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.getReviewModelsFilters,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// get filters for sku extrapolation page
export const getSkuListForExtrapolationFiltersAsync = createAsyncThunk(
  'api/cost-modelling/get-sku-list-for-extrapolation-filters',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.getFilters, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getSkuGroupsAsync = createAsyncThunk(
  '/api/v1/cost-modelling/sku-groups',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.getSkuGroups, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// delete sku grouping
export const deleteSkuGroupAsync = createAsyncThunk(
  '/api/v1/cost-modelling/delete-sku-group-by-id',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('DELETE', skuShouldCostWorkbenchApiRoutes?.deleteSkuGroup, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
// get ifa shorlsited sku count
export const ifaShorlistedSkuCountsAsync = createAsyncThunk(
  '/v1/cost-modelling/ifa-shortlisted-model-count',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'GET',
      skuShouldCostWorkbenchApiRoutes?.ifaShorlistedSkuCounts,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// get sku groups by filters extrapolation
export const getSkuGroupByFilter = createAsyncThunk(
  skuShouldCostWorkbenchApiRoutes?.getSkuGroupByFilter,
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.getSkuGroupByFilter,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// get skus by filters extrapolation
export const getSkusByFilter = createAsyncThunk(
  skuShouldCostWorkbenchApiRoutes?.getSkusByFilter,
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.getSkusByFilter, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// create sku groups
export const createSKUGroups = createAsyncThunk(
  skuShouldCostWorkbenchApiRoutes?.createSKUGroups,
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.createSKUGroups, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)
export const getSkuGroupFormulaAsync = createAsyncThunk(
  skuShouldCostWorkbenchApiRoutes?.getSkuGroupFormula,
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', skuShouldCostWorkbenchApiRoutes?.getSkuGroupFormula, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getExtrapolationSkuCountAsync = createAsyncThunk(
  skuShouldCostWorkbenchApiRoutes?.getExtrapolationSkuCount,
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.getExtrapolationSkuCount,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
    )
  },
)

export const getWithoutModelSkuCountAsync = createAsyncThunk(
  skuShouldCostWorkbenchApiRoutes?.getWithoutSkuCount,
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.getWithoutSkuCount, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const downloadShouldCostV2Async = createAsyncThunk(
  skuShouldCostWorkbenchApiRoutes?.downloadShouldCostV2,
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.downloadShouldCostV2,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// get logs percentage for uploading Should Cost Models to GTO
export const getUploadCostModelsLogsAsync = createAsyncThunk(
  '/api/v1/cost-modelling/get-upload-logs',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'GET',
      skuShouldCostWorkbenchApiRoutes?.getUploadCostModelsLogs,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// validate uploaded should cost model files (server-side sheet/structure check)
export const validateUploadedModelsAsync = createAsyncThunk(
  '/api/v1/cost-modelling/validate-uploaded-models',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.validateUploadedModels,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
  },
)

// Expected response shape:
// { valid: [{ filename }], invalid: [{ filename, message, details }], modelMetaData: {}, breakdownData: [] }
export const uploadShouldCostModelFromExcelAsync = createAsyncThunk(
  '/api/v1/model-uploader/library/validate-and-upload',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.uploadShouldCostModelFromExcel,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
  },
)

export const setFinalShouldCostModelV2 = createAsyncThunk(
  'api/should-cost-workbench/set-final-should-cost-model-v2',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.setFinalModelV2, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const uploadAndCalculateAsync = createAsyncThunk(
  '/api/v1/model-uploader/upload-and-calculate',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.uploadAndCalculate, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
)

export const getUploadModelStatusAsync = createAsyncThunk(
  '/api/v1/model-uploader/status',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.getUploadModelStatus,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const markSessionReviewedAsync = createAsyncThunk(
  'v1/model-uploader/mark-session-reviewed',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.markSessionReviewed,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const dismissUploadFailureBannerAsync = createAsyncThunk(
  'v1/model-uploader/error-logs',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'DELETE',
      skuShouldCostWorkbenchApiRoutes?.dismissUploadFailureBanner,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const abortUploadSessionAsync = createAsyncThunk(
  'v1/model-uploader/cancel-upload',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.abortUploadSession, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const downloadMultipleModelsAsync = createAsyncThunk(
  '/v1/model-uploader/download-multiple-models',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.downloadMultipleModels,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
      'blob',
    )
  },
)

// get eligible/ineligible counts for the review-uploaded-models drawer
export const getCountsForReviewModelsAsync = createAsyncThunk(
  'api/should-cost-workbench/get-counts-for-review-models',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.getCountsForReviewModels,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// get paginated eligible/ineligible models for the review-uploaded-models drawer
export const getReviewModelsAsync = createAsyncThunk(
  'api/should-cost-workbench/get-review-models',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.getReviewModels, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// delete multiple should-cost models
export const deleteMultipleModelsAsync = createAsyncThunk(
  'api/should-cost-workbench/delete-multiple-models',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.deleteMultipleModels,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
    )
  },
)

// validate which sscm ids can be newly shortlisted for IFA vs already shortlisted
export const validateShortlistingAsync = createAsyncThunk(
  'api/should-cost-workbench/validate-shortlisting',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.validateShortlisting,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
    )
  },
)

export const downloadUploadedErrorFileAsync = createAsyncThunk(
  '/v1/model-uploader/error-logs/download',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'GET',
      skuShouldCostWorkbenchApiRoutes?.downloadUploadedModelErrorFile,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
      'blob',
    )
  },
)

export const fetchMissingCommoditiesAsync = createAsyncThunk(
  '/api/v1/fetch-missing-commodities',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.getIndexTicker, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
